import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import GenericBaseResponseDTO from '../models/validation/GenericBaseResponseDTO';
import ClassroomReportResponseDTO from '../models/report/ClassroomReportResponseDTO';
import ReportSelectFiltersResultsDTO from '../models/report/ReportSelectFiltersResultsDTO';
import KeyValueDTO from '../models/generic/KeyValueDTO';
import PrincipalReportResponseDTO from '../models/report/PrincipalReportResponseDTO';
import SuperintendentReportResponseDTO from '../models/report/SuperintendentReportResponseDTO';
import StudentActivityReportDTO from '../models/report/StudentActivityReportDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import StudentStatementReportDTO from '../models/report/StudentStatementReportDTO';
import StudentPlanetCompletionReportDTO from '../models/report/StudentPlanetCompletionReportDTO';
import StudentGameCompletionReportDTO from '../models/report/StudentGameCompletionReportDTO';
import AdminReportRequestDTO from '../models/report/AdminReportRequestDTO';
import ClassroomReportRequestDTO from '../models/report/ClassroomReportRequestDTO';
import PostedIntArray from '../models/generic/PostedIntArray';
import ReportHeaderDTO from '../models/report/ReportHeaderDTO';
import ReportRequestDTO from '../models/datatable/ReportRequestDTO';

export class ReportApiController {
    // post: Report/GetAdminReport
    public RouteGetAdminReport = () => `Report/GetAdminReport`;
    public getAdminReport(request: AdminReportRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<string>>> {
        let url = this.RouteGetAdminReport();
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<string>>(request, 'post', url, requestOptions);
    }
    // post: Report/GetClassroomReport
    public RouteGetClassroomReport = () => `Report/GetClassroomReport`;
    public getClassroomReport(request: ClassroomReportRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<ClassroomReportResponseDTO>> {
        let url = this.RouteGetClassroomReport();
        return HttpApi.RestRequest<any, ClassroomReportResponseDTO>(request, 'post', url, requestOptions);
    }
    // get: Report/ExportClassroomReport/${classroomId}
    public RouteExportClassroomReport = (classroomId: number) => `Report/ExportClassroomReport/${classroomId}`;
    public exportClassroomReport(classroomId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteExportClassroomReport(classroomId);
        return HttpApi.RestRequest<any, void>(null, 'get', url, requestOptions);
    }
    // get: Report/GetStudentReport/${studentId}
    public RouteGetStudentReport = (studentId: number) => `Report/GetStudentReport/${studentId}`;
    public getStudentReport(studentId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<string>> {
        let url = this.RouteGetStudentReport(studentId);
        return HttpApi.RestRequest<any, string>(null, 'get', url, requestOptions);
    }
    // post: Report/FilterByCountries
    public RouteFilterByCountries = () => `Report/FilterByCountries`;
    public filterByCountries(countryIds: PostedIntArray, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<ReportSelectFiltersResultsDTO>> {
        let url = this.RouteFilterByCountries();
        return HttpApi.RestRequest<any, ReportSelectFiltersResultsDTO>(countryIds, 'post', url, requestOptions);
    }
    // post: Report/FilterByStates
    public RouteFilterByStates = () => `Report/FilterByStates`;
    public filterByStates(stateIds: PostedIntArray, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<ReportSelectFiltersResultsDTO>> {
        let url = this.RouteFilterByStates();
        return HttpApi.RestRequest<any, ReportSelectFiltersResultsDTO>(stateIds, 'post', url, requestOptions);
    }
    // post: Report/FilterByDistricts
    public RouteFilterByDistricts = () => `Report/FilterByDistricts`;
    public filterByDistricts(districtIds: PostedIntArray, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteFilterByDistricts();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(districtIds, 'post', url, requestOptions);
    }
    // get: Report/GetCountriesForSelect
    public RouteGetCountryHavingStates = () => `Report/GetCountriesForSelect`;
    public getCountryHavingStates(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetCountryHavingStates();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // get: Report/GetPrincipalReport
    public RouteGetPrincipalReport = () => `Report/GetPrincipalReport`;
    public getPrincipalReport(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<PrincipalReportResponseDTO[]>> {
        let url = this.RouteGetPrincipalReport();
        return HttpApi.RestRequest<any, PrincipalReportResponseDTO[]>(null, 'get', url, requestOptions);
    }
    // get: Report/ExportPrincipalReport
    public RouteExportPrincipalReport = () => `Report/ExportPrincipalReport`;
    public exportPrincipalReport(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteExportPrincipalReport();
        return HttpApi.RestRequest<any, void>(null, 'get', url, requestOptions);
    }
    // get: Report/GetSuperintendentReport
    public RouteGetSuperintendentReport = () => `Report/GetSuperintendentReport`;
    public getSuperintendentReport(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<SuperintendentReportResponseDTO[]>> {
        let url = this.RouteGetSuperintendentReport();
        return HttpApi.RestRequest<any, SuperintendentReportResponseDTO[]>(null, 'get', url, requestOptions);
    }
    // get: Report/ExportSuperintendentReport
    public RouteExportSuperintendentReport = () => `Report/ExportSuperintendentReport`;
    public exportSuperintendentReport(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteExportSuperintendentReport();
        return HttpApi.RestRequest<any, void>(null, 'get', url, requestOptions);
    }
    // post: Report/GetStudentActivityReport
    public RouteGetStudentActivityReport = () => `Report/GetStudentActivityReport`;
    public getStudentActivityReport(tableRequest: ReportRequestDTO<ReportHeaderDTO>, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<StudentActivityReportDTO>>> {
        let url = this.RouteGetStudentActivityReport();
        return HttpApi.RestRequest<any, TableResponseDTO<StudentActivityReportDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // post: Report/GetStudentStatementReport
    public RouteGetStudentStatementReport = () => `Report/GetStudentStatementReport`;
    public getStudentStatementReport(tableRequest: ReportRequestDTO<ReportHeaderDTO>, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<StudentStatementReportDTO>>> {
        let url = this.RouteGetStudentStatementReport();
        return HttpApi.RestRequest<any, TableResponseDTO<StudentStatementReportDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // post: Report/GetStudentPlanetCompletionReport
    public RouteGetStudentPlanetCompletionReport = () => `Report/GetStudentPlanetCompletionReport`;
    public getStudentPlanetCompletionReport(tableRequest: ReportRequestDTO<ReportHeaderDTO>, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<StudentPlanetCompletionReportDTO>>> {
        let url = this.RouteGetStudentPlanetCompletionReport();
        return HttpApi.RestRequest<any, TableResponseDTO<StudentPlanetCompletionReportDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // post: Report/GetStudentGameCompletionReport
    public RouteGetStudentGameCompletionReport = () => `Report/GetStudentGameCompletionReport`;
    public getStudentGameCompletionReport(tableRequest: ReportRequestDTO<ReportHeaderDTO>, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<StudentGameCompletionReportDTO>>> {
        let url = this.RouteGetStudentGameCompletionReport();
        return HttpApi.RestRequest<any, TableResponseDTO<StudentGameCompletionReportDTO>>(tableRequest, 'post', url, requestOptions);
    }
}
var service = new ReportApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/ReportApiController.ts